import { motion } from "framer-motion";
import { CHARLIE } from "../lib/api";

const PAGE = {
  n: "i.",
  title: "A different kind of loving",
  body: "'Some people love well,' Momma says. 'Others love differently.' She lets the sentence sit for a moment. 'That isn't your fault, little one. And it isn't your fix.'",
  caption: "on the sentence that changes everything",
};

export default function PeekInsideBook() {
  return (
    <section data-testid="peek-inside" className="relative py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-6 items-end mb-12">
          <div className="md:col-span-7">
            <div className="mono text-[11px] tracking-[0.28em] uppercase text-[#4A7C7B] mb-4">A taste of Book One</div>
            <h2 className="serif text-[clamp(2.25rem,5.5vw,4.5rem)] leading-[1.02] tracking-tight text-espresso">
              One small <span className="italic">window.</span>
            </h2>
          </div>
          <div className="md:col-span-5 text-sm text-charcoal/85 leading-relaxed">
            An illustrative sample of the voice we're writing in — one small window into Charlie's world, chosen for tone rather than plot.
          </div>
        </div>

        <div className="grid md:grid-cols-12 gap-6 md:gap-10 items-stretch">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.8 }}
            className="md:col-span-6"
          >
            <div className="relative torn-frame bg-[#FFFDF9] overflow-hidden aspect-[4/5]">
              <img
                src={CHARLIE.sketches}
                alt="Sketches of Charlie by Zuzana Svobodová"
                className="absolute inset-0 w-full h-full object-cover object-center opacity-95"
              />
              <div className="absolute inset-0 spotlight opacity-70 mix-blend-multiply" />
              <div className="absolute bottom-4 left-4 mono text-[10px] tracking-[0.28em] uppercase text-espresso/70 bg-[#FAF8F5]/80 px-2 py-1 rounded">
                Sketchbook · Charlie
              </div>
            </div>
            <div className="italic-serif text-xs text-charcoal/55 mt-4">
              Illustrations by Zuzana Svobodová
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="md:col-span-6 flex flex-col justify-center relative"
          >
            <div className="chapter-number text-[9rem] md:text-[13rem] absolute -top-14 md:-top-24 -left-2 opacity-30 select-none pointer-events-none">
              {PAGE.n}
            </div>
            <div className="relative pt-4 md:pt-8">
              <div className="mono text-[10px] tracking-[0.28em] uppercase text-[#4A7C7B]">
                Sample passage — {PAGE.caption}
              </div>
              <h3 data-testid="peek-page-title" className="serif text-3xl md:text-5xl leading-[1.08] tracking-tight text-espresso mt-4">
                {PAGE.title}
              </h3>
              <p data-testid="peek-page-body" className="italic-serif text-lg md:text-xl leading-relaxed text-charcoal mt-6 max-w-lg">
                {PAGE.body}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
